import React from "react";

import { StyledLink } from "./CustomLink.styles";

const CustomLink = ({ to, children }) => {
  return <StyledLink to={to}>{children}</StyledLink>;
};

export default CustomLink;
